import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoClose, IoMenu } from "react-icons/io5";
import LanguageSelector from "../../Common/LangauageSelector";
const Navbar = () => {
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <>
      {/* <LanguageSelector /> */}
      <nav className="border-gray-200 bg-blueBg py-2 shadow-lg lg:px-14">
        <div className="flex items-center justify-between px-4 md:px-6 py-2">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-marcellus pl-2 text-white">
              Rammohan Naidu Kinjarapu
            </h1>
          </Link>

          {/* Navigation for Large Screens */}
          <div className="lg:flex space-x-6 text-white font-medium items-center">
            {!isHome && (
              <Link to="https://www.rammnk.com/" target="_blank" className="font-marcellus footer-link">
                Home
              </Link>
            )}
            {/* <div
              className="hidden lg:flex space-x-8 text-white font-medium items-center"
              onMouseEnter={() => setShowDropdown(true)}
              
            >
              <Link className="font-marcellus footer-link tracking-[0.2em]">
                News
              </Link>
              <Link className="font-marcellus footer-link tracking-[0.2em]">
                Gallery
              </Link>
              <Link className="font-marcellus footer-link tracking-[0.2em]">
                About
              </Link>
              <Link className="font-marcellus footer-link tracking-[0.2em]">
                Governance
              </Link>
            </div> */}
          </div>

          {/* Menu Icon for Medium and Smaller Screens */}
          {/* <button
            className="text-3xl text-white block lg:hidden"
            onClick={() => setShowMobileNav(!showMobileNav)}
          >
            {showMobileNav ? <IoClose /> : <IoMenu />}
          </button> */}
        </div>
      </nav>
      {/* Dropdown for Large Screens (Hover) */}
      {showDropdown && (
        <div
          className="hidden absolute top-18 right-0 left-0  z-[999]  bg-[#4e2222] rounded-bl-lg rounded-br-lg lg:block text-white lg:mx-20 py-6 px-4 border-t border-gray-600 bg-opacity-95"
          onMouseEnter={() => setShowDropdown(true)}
          onMouseLeave={() => setShowDropdown(false)}
        >
          <div className="grid grid-cols-4 gap-6 container px-24 mx-auto text-start">
            <div>
              <h3 className="font-marcellus mb-4 font-medium tracking-[0.4em] text-green-100">
                ABOUT RMK
              </h3>
              <ul className="space-y-2 mt-4">
                <li>
                  <Link
                    to="/about"
                    className="footer-link font-montsettat text-md"
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link
                    to="/tdp-connect"
                    className="footer-link font-montsettat text-md"
                  >
                    TDP Connect
                  </Link>
                </li>
                <li>
                  <Link
                    to="/speech"
                    className="footer-link font-montsettat text-md"
                  >
                    Speeches
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium font-marcellus mb-4 tracking-[0.4em] text-green-100">
                NEWS
              </h3>
              <ul className="space-y-2 mt-4">
                <li>
                  <Link
                    to="/news-update"
                    className="footer-link font-montsettat text-md"
                  >
                    News Updates
                  </Link>
                </li>
                <li>
                  <Link
                    to="/media-coverage"
                    className="footer-link font-montsettat text-md"
                  >
                    Media Coverage
                  </Link>
                </li>
                <li>
                  <Link
                    to="/news-letter"
                    className="footer-link font-montsettat text-md"
                  >
                    Newsletter
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium font-marcellus mb-4 tracking-[0.4em] text-green-100">
                GALLERY
              </h3>
              <ul className="space-y-2 mt-4">
                <li>
                  <Link
                    to="/gallery"
                    className="footer-link font-montsettat text-md"
                  >
                    Image Gallery
                  </Link>
                </li>
                <li>
                  <Link
                    to="/video-gallery"
                    className="footer-link font-montsettat text-md"
                  >
                    Video Gallery
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium font-marcellus mb-4 tracking-[0.4em] text-green-100">
                GOVERNANCE
              </h3>
              <ul className="space-y-2 mt-4">
                <li>
                  <Link
                    to="/team"
                    className="footer-link font-montsettat text-md"
                  >
                    AMO
                  </Link>
                </li>
                <li>
                  <Link
                    to="/scorecard"
                    className="footer-link font-montsettat text-md"
                  >
                    Scorecard
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://seva.rammnk.com/"
                    className="footer-link font-montsettat text-md"
                  >
                    SEVA
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Menu Dropdown (Click) */}
      {showMobileNav && (
        <div className="lg:hidden bg-[#4e2222] text-white py-6 px-4 border-t">
          <div className="grid grid-cols-1 gap-6 mx-auto">
            <div>
              <h3 className="font-medium font-marcellus mb-4 tracking-[0.4em] text-green-100">
                ABOUT RMK
              </h3>
              <ul className="space-y-2 mt-4">
                <li>
                  <Link
                    to="/about"
                    className="footer-link font-montsettat text-md"
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link
                    to="/tdp-connect"
                    className="footer-link font-montsettat text-md"
                  >
                    TDP Connect
                  </Link>
                </li>
                <li>
                  <Link
                    to="/speech"
                    className="footer-link font-montsettat text-md"
                  >
                    Speeches
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium font-marcellus mb-4 tracking-[0.4em] text-green-100">
                NEWS
              </h3>
              <ul className="space-y-2 mt-4">
                <li>
                  <Link
                    to="/news-update"
                    className="footer-link font-montsettat text-md"
                  >
                    News Updates
                  </Link>
                </li>
                <li>
                  <Link
                    to="/media-coverage"
                    className="footer-link font-montsettat text-md"
                  >
                    Media Coverage
                  </Link>
                </li>
                <li>
                  <Link
                    to="/news-letter"
                    className="footer-link font-montsettat text-md"
                  >
                    Newsletter
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium font-marcellus mb-4 tracking-[0.4em] text-green-100">
                GALLERY
              </h3>
              <ul className="space-y-2 mt-4">
                <li>
                  <Link
                    to="/gallery"
                    className="footer-link font-montsettat text-md"
                  >
                    Image Gallery
                  </Link>
                </li>
                <li>
                  <Link
                    to="/video-gallery"
                    className="footer-link font-montsettat text-md"
                  >
                    Video Gallery
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium font-marcellus mb-4 tracking-[0.4em] text-green-100">
                GOVERNANCE
              </h3>
              <ul className="space-y-2 mt-4">
                <li>
                  <Link
                    to="/team"
                    className="footer-link font-montsettat text-md"
                  >
                    AMO
                  </Link>
                </li>
                <li>
                  <Link
                    to="/scorecard"
                    className="footer-link font-montsettat text-md"
                  >
                    Scorecard
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://seva.rammnk.com/"
                    className="footer-link font-montsettat text-md"
                  >
                    SEVA
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;

// import { Link } from "react-router-dom";
// import { FaSearch } from "react-icons/fa";

// const Navbar = () => {
//   const [activeDropdown, setActiveDropdown] = useState(null);

//   const menuItems = [
//     {
//       label: "Visit",
//       sections: [
//         {
//           title: "ON THE MOUNTAIN",
//           links: [
//             "Special Events",
//             "Weekly Yoga Classes",
//             "Shop",
//             "Study",
//             "Host Your Group",
//           ],
//         },
//         {
//           title: "ANNUAL RETREATS",
//           links: [
//             "Going Deeper Meditation Retreat",
//             "Liberation Yoga Retreat",
//             "New Year's Yoga Retreat",
//             "Living Yoga Spring Retreat",
//           ],
//         },
//         {
//           title: "PATHWAYS TO VISIT",
//           links: [
//             "Personal Overnight Retreats",
//             "Mountain Experience Day Visit",
//             "Kaya Kalpa Wellness Center",
//           ],
//           special: "Sankat Mochan Hanuman Temple",
//         },
//       ],
//     },
//     {
//       label: "Study",
//     },
//     {
//       label: "Venue",
//     },
//     {
//       label: "Online",
//     },
//     {
//       label: "Calendar",
//     },
//     {
//       label: "About",
//     },
//   ];

//   return (
//     <nav className="bg-[#d2b48c] text-black py-4 px-6 relative">
//       <div className="flex justify-between items-center">
//         <div className="text-xl font-bold">MOUNT MADONNA</div>
//         <div className="flex space-x-6 relative">
//           {menuItems.map((menu, index) => (
//             <div
//               key={index}
//               className="relative group"
//               onMouseEnter={() => setActiveDropdown(menu.label)}
//               onMouseLeave={() => setActiveDropdown(null)}
//             >
//               <span className="cursor-pointer hover:text-gray-700">{menu.label}</span>
//               {activeDropdown === menu.label && menu.sections && (
//                 <div className="absolute z-[999] left-0 top-0 w-full bg-[#4c2323] text-white shadow-lg p-6 flex space-x-8">
//                   {menu.sections.map((section, idx) => (
//                     <div key={idx}>
//                       <h4 className="text-lg font-semibold mb-3 border-b border-[#a67c52] pb-1">
//                         {section.title}
//                       </h4>
//                       <ul>
//                         {section.links.map((link, i) => (
//                           <li key={i} className="hover:text-gray-300 cursor-pointer mb-2">
//                             {link}
//                           </li>
//                         ))}
//                       </ul>
//                       {section.special && (
//                         <div className="mt-4 font-semibold flex items-center">
//                           <span className="mr-2">🏛️</span> {section.special}
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                   <div className="w-[200px] bg-cover bg-center p-6 rounded-lg" style={{ backgroundImage: "url('https://source.unsplash.com/200x300/?lotus')" }}>
//                     <h4 className="text-lg font-semibold">LEARN MORE</h4>
//                     <ul className="mt-3 space-y-2">
//                       <li className="hover:text-gray-300 cursor-pointer">Campus</li>
//                       <li className="hover:text-gray-300 cursor-pointer">Directions & Maps</li>
//                       <li className="hover:text-gray-300 cursor-pointer">FAQs</li>
//                       <li className="hover:text-gray-300 cursor-pointer">Covid-19 Policy</li>
//                     </ul>
//                     <button className="border border-white px-4 py-1 mt-4 rounded-md hover:bg-white hover:text-black">CONTACT</button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           ))}
//           <FaSearch className="cursor-pointer" />
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;